import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StateConfig, StateModule, StateTransferType, provideDefaultConfigFactory } from '@spartacus/core';
import { AREA_OF_USE_ADMIN_FEATURE } from './area-of-use-admin-state';
import { effects } from './effects/index';
import { metaReducers, reducerProvider, reducerToken } from './reducers/index';

export function areaOfUseAdminStoreConfigFactory(): StateConfig {
  const config: StateConfig = {
    state: {
      ssrTransfer: {
        keys: {
          [AREA_OF_USE_ADMIN_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
  return config;
}

@NgModule({
  imports: [
    CommonModule,
    StateModule,
    StoreModule.forFeature(AREA_OF_USE_ADMIN_FEATURE, reducerToken, { metaReducers }),
    EffectsModule.forFeature(effects),
    RouterModule,
  ],
  providers: [reducerProvider, provideDefaultConfigFactory(areaOfUseAdminStoreConfigFactory)],
})
export class AreaOfUseAdminStoreModule {}
